import React from 'react'

import Collapsible from 'react-collapsible';
import Border from '../Border'
import Product from '../Product'
import AddProduct from '../AddProduct';

import Section from './editable/Section'

import Backend from '../../utils/Backend'

import Titles from './editable/Titles';
import AsyncSelect from "../common/CCAsyncSelect";
import Navigation from "../../utils/Navigation";
import ProductCardColorSwatchSettings from '../ProductCardColorSwatchSettings';

import Block from "./Block";

const PRODUCTS_NO_OPTIONS = [
  {
    label: "3",
    value: 3
  },
  {
    label: "6",
    value: 6
  },
  {
    label: "9",
    value: 9
  }
]

export default class Block39 extends Block {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
      selectedProducts: [],
      editable: props.editable
    }

  }

  componentDidMount(){
    this._setUp()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._setUp())
  }

  _setUp(){
    let {
      data,
      selectedProducts
    } = this.state

    let productIds = data.extra?.selected_products.map(product => product.productId) || []

    if(selectedProducts.length === 0){
      this._loadProducts(productIds)
    }
  }

  _loadProducts(productIds){
    let {
      data,
    } = this.state

    this.setState({ loading: true })
    Backend.getProducts(productIds.join(",")).then(products => {
      let orderedProducts = productIds
          .map(id => products.find(p => p.campaignProductId === id))
          .filter(Boolean);
      orderedProducts = orderedProducts.slice(0, data.extra?.products_no || 3);
      this.setState({ selectedProducts: orderedProducts, loading: false });
    }).catch(() => this.setState({ loading: false }));
  }

  _update(data, callback){
    this.setState({ ...data }, () => {

      if(callback){
        callback()
      }
      this.updateContentBlock()
    })
  }

  _getModalContent(data){
    return (
      <>
        <Border>
          <Collapsible
            trigger="Number of products to be displayed"
          >
            <br/>
            <div className="input-select">
              <select
                value={data.extra?.products_no || 3}
                onChange={e => {

                  if(!data.extra) {
                    data.extra = {selected_products:[], products_no: 3}
                  }

                  data.extra.products_no = parseInt(e.target.value)

                  data.extra.selected_products.splice(data.extra?.products_no, data.extra?.selected_products.length - data.extra?.products_no);
                  this._update({
                    data,
                    loading: true
                  }, () => this._loadProducts(data.extra?.selected_products.map(product => product.productId) || []))
                }}
              >
                {
                  PRODUCTS_NO_OPTIONS.map(option => {
                    return (
                      <option value={option.value}>{ option.label }</option>
                    )
                  })
                }
              </select>
            </div>
          </Collapsible>
        </Border>
        { this._renderSelectProducts(data) }
        <ProductCardColorSwatchSettings
          data={data}
          update={(obj) => {
            this._update(obj)
          }}
        />
      </>
    )
  }

  _getProductOption(product){
    if(!product){
      return null
    }

    return {
      label: product.productName,
      value: product.productId,
      data: product
    }
  }

  _renderSelectProducts(data){
    let content = []
    let selectedProductArray = Array.apply(null, Array(data.extra?.products_no || 3))

    selectedProductArray.map((selectedProduct, index) => {
      if(index < data.extra?.selected_products.length){
        selectedProduct = data.extra.selected_products[index]
      }
      content.push(
        <>
          <label>{`Select Product #${index + 1}`}</label>
          <AsyncSelect
            endpoint={window.CCApi.Products}
            classNamePrefix="async-select-paginate"
            placeholder="Please Select A Product"
            noOptionsMessage={() => "No Products Found"}
            value={this._getProductOption(selectedProduct)}
            onSelected={product => {
              if(!data.extra) {
                data.extra = {selected_products:[], products_no: 3}
              }

              if(index <= data.extra?.selected_products.length - 1){
                data.extra.selected_products.splice(index, 1, product)
              }
              else{
                data.extra.selected_products.push(product)
              }

              this.setState({ data }, () => this._loadProducts(data.extra?.selected_products.map(product => product.productId) || []))
              this._update({
                data,
              })
            }}
            getOptions={options => options.map(option => this._getProductOption(option[1]))}
          />
        </>
      )
    })

    return (
     <Border>
        <Collapsible
          trigger="Select Products"
        >
          <br/>
          { content }
        </Collapsible>
      </Border>
    )
  }
  _renderProducts(products){
    let {
      loading
    } = this.state

    return products.map(product => {
      return (
        <Product
          key={product?.id}
          product={product}
          onAddToCartPressed={(product, variant, customMessage, quantity) => this.props.onAddToCartPressed(product, variant, customMessage, quantity)}
          data={this.state.data}
        />
      )
    })
  }

  render(){
    let { loading, data, editable, selectedProducts } = this.state

    if(!loading && !editable && data.extra?.selected_products.length === 0){
      return null
    }

    if(!editable && selectedProducts.length == 0){
      return null
    }

    let blockClassName = " block-39 product-blocks  ";
    let viewAllClassName = " mt--2  ";
    if (window.IS_CARD_STYLE_WEBSITE) {
      blockClassName += " deep-cardify";
      viewAllClassName = " dc-mt-1 ";
    }

    return (
      <Section
        data={ data }
        index={ this.props.index }
        className={ blockClassName }
        editable={ editable }
        onUpdated={data => this._update({ data })}
        onDelete={() => this.props.onDelete()}
        onAddContentBlockPressed={contentBlock => this.props.onAddContentBlockPressed(contentBlock)}
        renderModalContent={() => this._getModalContent(data)}
        canMoveUp={ this.props.canMoveUp }
        canMoveDown={ this.props.canMoveDown }
        onVisibilityButtonPressed={(index) => this.props.onVisibilityButtonPressed(index)}
        onMoveUpPressed={ () => this.props.onMoveUpPressed() }
        onMoveDownPressed={ () => this.props.onMoveDownPressed() }
        onVisibilityToggled={() => this.props.onVisibilityToggled()}
      >
        <div className="container">

          {((selectedProducts?.length === 0 || !selectedProducts) && !loading) &&
            <AddProduct/>
          }
          { selectedProducts?.length >  0 &&
            <>
              <Titles
                data={ data }
                editable={ editable }
                onUpdated={data => this._update(data)}
                rowCssClasses={"dc-mb-1"}
                alignment={"text-left"}
                headingNumber={2}
                headingDefaultText={"Selected Products"}
              />

              <hr className='dc-d-none' />

              {/* starts, blocks  */}
              <div className="row mt-5 dc-row-v3">

                { this._renderProducts(selectedProducts) }

              </div>
              {/* end, blocks  */}

            </>
          }
        </div>
      </Section>
    )
  }
}
